import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from "prop-types";
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button'
import * as actionCreators from '../../actions/auth';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew'
import PersonIcon from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/Menu'
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';


const styles = {
    // This group of buttons will be aligned to the right
    rightToolbar: {
        marginLeft: 'auto',
        marginRight: -12,
    },
    centerToolbar: {
        marginLeft: 100,
        marginRight: -12,
    },
    menuButton: {
        marginRight: 16,
        marginLeft: -12,
    },
};



function mapStateToProps(state) {
    return {
        token: state.auth.token,
        userName: state.auth.userName,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}


@connect(mapStateToProps, mapDispatchToProps)
export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isMenuOpen: false,
            anchorEl: null,
        };

    }

    dispatchNewRoute(route) {
        browserHistory.push(route);
        this.setState({
            open: false,
        });

    }

    handleClickOutside() {
        this.setState({
            open: false,
        });
    }

    logout(e) {
        e.preventDefault();
        this.props.logoutAndRedirect();
        this.setState({
            open: false,
        });
    }
    getUserSettings = (e) => {
        e.preventDefault()
        this.props.redirectToRoute('user_settings')
    }
    openNav() {
        this.setState({
            open: true,
        });
    }
    showMenu = event => {
        this.setState({ isMenuOpen: true, anchorEl: event.currentTarget });
    };

    closeMenu = () => {
        this.setState({ anchorEl: null, isMenuOpen: false });
    };


    send(e) {
        e.preventDefault();
        this.props.history.push('/mytickets')

    }

    goToIndex = e => {
        e.preventDefault();
        this.props.redirectToRoute('mytickets')
    }

    goToMain = e => {
        this.props.redirectToRoute('/main')

    }
    switchMenu = (value) => {
        this.props.switchMenu(true)
    }
    render() {
        const classes = this.props;
        let menuVar = NaN;
        if (!this.props.isAuthenticated) {
            menuVar = (menuVar = (<Toolbar position="static" >
                <img src='https://lisboa.arrobatech.com.ar/static/img/logo.jpg' alt="Logo" width="80" height="80" />
                <Typography variant='h4' style={{ color: 'white' }}>Market</Typography>
                <section style={{ flex: 10 }}></section>
                <section style={{ flex: 1 }}>
                </section>
            </Toolbar>))
        }

        else {
            menuVar = (<Toolbar position="static" >

                <img src='https://lisboa.arrobatech.com.ar/static/img/logo.jpg' alt="Logo" width="80" height="80" />
                <IconButton onClick={(e) => this.goToMain()}>
                    <Typography variant='h4' style={{ color: 'white' }}>Market</Typography>
                </IconButton>
                <section style={{ flex: 8 }}></section>
                <section style={{ flex: 2 }}>
                    <IconButton onClick={(e) => this.logout(e)}>
                        <PowerSettingsNew />

                    </IconButton>

                    <IconButton onClick={(e) => this.getUserSettings(e)}>
                        <PersonIcon />

                    </IconButton>


                    <IconButton onClick={(e) => this.switchMenu(e.target.value)}>
                        <MenuIcon />

                    </IconButton>




                </section>
            </Toolbar>)
        }
        return (
            <header>
                <AppBar position="fixed">
                    {menuVar}
                </AppBar>
            </header>

        );
    }
}

Header.propTypes = {
    logoutAndRedirect: PropTypes.func,
    redirectToRoute: PropTypes.func,
    isAuthenticated: PropTypes.bool,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js